import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {
  QuickQuestionShowFormAnimation,
  QuickQuestionWelcomeLogoAnimation,
  QuickQuestionWelcomeTextAnimation,
} from '@api-ui-app/src/app/on-boarding/constants/quick-question-welcome-animations';
import { AppState } from '@api-ui-app/src/app/app.state';
import { Store } from '@ngrx/store';
import { LocaleCode } from '@gelato-api-ui/core/i18n/locales.constant';
import { updateLocale } from '@gelato-api-ui/sdk/src/lib/sdk.actions';
import { TranslateService } from '@ngx-translate/core';
import { ResponsiveService } from '@gelato-api-ui/core/responsive/responsive.service';

@Component({
  selector: 'gd-on-boarding-layout',
  templateUrl: './on-boarding-layout.component.html',
  styleUrls: ['./on-boarding-layout.component.scss'],
  animations: [QuickQuestionWelcomeTextAnimation, QuickQuestionWelcomeLogoAnimation, QuickQuestionShowFormAnimation],
})
export class OnBoardingLayoutComponent implements AfterViewChecked, AfterViewInit {
  @ViewChild('logo', { read: ElementRef }) logo: ElementRef<HTMLElement>;

  contentOffset = 80;
  contentTransformStyle$ = new BehaviorSubject('translate(0, 0)');
  welcomeStart$ = new BehaviorSubject(false);
  welcomeTextStart$ = new BehaviorSubject(false);
  performingAnimation$ = new BehaviorSubject(true);
  isMobile$ = this.responsive.isMobile$;

  constructor(
    readonly translationsService: TranslateService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly responsive: ResponsiveService,
    private store: Store<AppState>,
  ) {}

  ngAfterViewInit() {
    this.welcomeStart$.next(true);
    this.welcomeTextStart$.next(true);
    setTimeout(() => {
      this.welcomeTextStart$.next(false);
    }, 2600);
  }

  ngAfterViewChecked() {
    const offset = this.logo?.nativeElement.offsetTop || 0;

    const style = offset > this.contentOffset ? `translate(0, -${this.contentOffset}px)` : 'translate(0, 0)';
    if (style !== this.contentTransformStyle$.value) {
      this.contentTransformStyle$.next(style);
      this.cdRef.detectChanges();
    }
  }

  finishAnimation(): void {
    this.performingAnimation$.next(false);
  }

  onUseLocale(locale: LocaleCode) {
    this.store.dispatch(updateLocale({ locale }));
  }
}
